module.exports = __webpack_public_path__ + "static/media/SIH2022.ff59c6e9.pdf";